import React from 'react';

const renderInput = ({ input, id, label, min, type, placeholder, brand, className, disabled, mutedText, meta: { touched, error } }) => (
  <div className={'form-group'}>
    {label && <label className='inputLabel'>{label}</label>}
    <input {...input} id={id ||input.name} disabled={disabled} min={min} placeholder={placeholder} type={type} className={(touched && error) ? 'form-control is-invalid' : 'form-control'} />
    {mutedText && <small className="form-text text-muted">{mutedText}</small>}
    {touched && error && <span className='invalid-feedback'>{error}</span>}
  </div>
)

export default renderInput;


// WEBPACK FOOTER //
// ./src/components/Input/index.js